<div class="position-relative rounded-3 border custom-border custom-bg custom-shadow" [ngClass]="[selectedTemplate ? '' : 'overflow-auto']">
  <app-badge-template-creation *ngIf="selectedTemplate" [selectedTemplate]="selectedTemplate" [badgeForm]="badgeForm"></app-badge-template-creation>
  <app-badge-template-selection
    *ngIf="!selectedTemplate"
    [badgeForm]="badgeForm"
    (onBadgeSelected)="selectTemplate($event)"
    (onCancel)="onCancel.emit()"
    class="overflow-auto h-100 d-block"
  ></app-badge-template-selection>
</div>
